export default __webpack_public_path__ + "static/media/partyPopper.cb238b28.svg";